module.exports = __webpack_public_path__ + "d489f4a9d965f5841e328fcafc59912f.jpg";